<template>
  <div class="sidebar">
    <ul class="baritems" v-if="!empty">
      <router-link to="/plans/select" v-show="!isAuditing">
        <li>Select EHCP</li>
      </router-link>
      <!-- <router-link to="/plans/details"> -->
      <a
        :class="{ 'is-active': $route.params.id === 'a' }"
        @click="didClickNavigateToSection('a')"
        v-show="isAuditing"
      >
        <li>
          Section A
          {{ showIfDirty('a') }}
        </li>
      </a>
      <a
        :class="{ 'is-active': $route.params.id === 'b' }"
        @click="didClickNavigateToSection('b')"
        v-show="isAuditing"
      >
        <li>
          Section B
          {{ showIfDirty("b") }}
        </li>
      </a>
      <a
        :class="{ 'is-active': $route.params.id === 'c' }"
        @click="didClickNavigateToSection('c')"
        v-show="isAuditing"
      >
        <li>
          Section C
          {{ showIfDirty("c") }}
        </li>
      </a>
      <a
        :class="{ 'is-active': $route.params.id === 'd' }"
        @click="didClickNavigateToSection('d')"
        v-show="isAuditing"
      >
        <li>
          Section D
          {{ showIfDirty("d") }}
        </li>
      </a>
      <a
        :class="{ 'is-active': $route.params.id === 'e' }"
        @click="didClickNavigateToSection('e')"
        v-show="isAuditing"
      >
        <li>
          Section E
          {{ showIfDirty("e") }}
        </li>
      </a>
      <a
        :class="{ 'is-active': $route.params.id === 'f' }"
        @click="didClickNavigateToSection('f')"
        v-show="isAuditing"
      >
        <li>
          Section F
          {{ showIfDirty("f") }}
        </li>
      </a>
      <a
        :class="{ 'is-active': $route.params.id === 'g' }"
        @click="didClickNavigateToSection('g')"
        v-show="isAuditing"
      >
        <li>
          Section G
          {{ showIfDirty("g") }}
        </li>
      </a>
      <a
        :class="{ 'is-active': $route.params.id === 'h1' }"
        @click="didClickNavigateToSection('h1')"
        v-show="isAuditing"
      >
        <li>
          Section H1
          {{ showIfDirty("h1") }}
        </li>
      </a>
      <a
        :class="{ 'is-active': $route.params.id === 'h2' }"
        @click="didClickNavigateToSection('h2')"
        v-show="isAuditing"
      >
        <li>
          Section H2
          {{ showIfDirty("h2") }}
        </li>
      </a>
      <a
        :class="{ 'is-active': $route.params.id === 'i' }"
        @click="didClickNavigateToSection('i')"
        v-show="isAuditing"
      >
        <li>
          Section I
          {{ showIfDirty("i") }}
        </li>
      </a>
      <a
        :class="{ 'is-active': $route.params.id === 'j' }"
        @click="didClickNavigateToSection('j')"
        v-show="isAuditing"
      >
        <li>
          Section J
          {{ showIfDirty("j") }}
        </li>
      </a>
      <a
        :class="{ 'is-active': $route.params.id === 'k' }"
        @click="didClickNavigateToSection('k')"
        v-show="isAuditing"
      >
        <li>
          Section K
          {{ showIfDirty("k") }}
        </li>
      </a>
      <a
        :class="{ 'is-active': path === 'qa' }"
        @click="didClickNavigateTo('qa')"
        v-show="isAuditing"
      >
        <li>
          Additional Components 1
          {{ showIfDirty("qa") }}
        </li>
      </a>
      <a
        :class="{ 'is-active': path === 'additional' }"
        @click="didClickNavigateTo('additional')"
        v-show="isAuditing"
      >
        <li>
          Additional Components 2
          {{ showIfDirty("additional") }}
        </li>
      </a>
      <a
        :class="{ 'is-active': path === 'summary' }"
        @click="didClickNavigateTo('summary')"
        v-show="isAuditing"
      >
        <li>Gradings</li>
      </a>
      <!-- <li class="text-sm">Submit Gradings</li> -->
    </ul>
    <ul class="baritems" v-else>
      <router-link to="/support">
        <li>Help and Support</li>
      </router-link>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SideBar',
  props: ['empty', 'touched'],
  computed: {
    ...mapGetters({
      sections: 'audit/sections',
      nextSection: 'audit/nextSection',
      currentAudit: 'audit/id'
    }),
    path () {
      return this.$route.path.split('/').pop()
    },
    isAuditing () {
      return !!this.currentAudit
    }
  },
  methods: {
    didClickNavigateToSection (section) {
      return this.$router.push({
        path: `/plans/section/${section}`,
        query: { regrade: true }
      })
    },
    didClickNavigateTo (page) {
      // const hasCompletedSection = this.sections.some(s => s.id === page)
      if (page !== this.path && page === 'summary') {
        this.$emit('nav-clicked', { id: this.path })
        return this.$router.push({
          path: `/plans/audit/${page}`
        })
      } else if (page !== this.path) {
        this.$emit('nav-clicked', { id: this.path })
        return this.$router.push({
          path: `/plans/audit/${page}`,
          query: { regrade: true }
        })
      }
    },
    didClickViewGradings () {
      // if (this.hasCompletedSection('additional')) {
      // }
      this.$emit('nav-clicked', { id: this.path })
      return this.$router.push('/plans/audit/summary')
    },
    hasCompletedSection (section) {
      return this.sections.some(s => s.id === section)
    },
    showIfDirty (section) {
      if (this.touched.length) {
        return this.touched.some(s => s === section) ? ' *' : ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/style/variables.scss";
@import "@/style/nav.scss";

.text-sm {
  font-size: 0.75rem;
}
</style>
